import React from 'react';
import { Clock, User, Tag } from 'lucide-react';

const TicketCard = ({ ticket, onClick, getPriorityColor, getStatusIcon }) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    const now = new Date();
    const diffInHours = Math.floor((now - date) / (1000 * 60 * 60));
    
    if (diffInHours < 1) return 'Just now';
    if (diffInHours < 24) return `${diffInHours}h ago`;
    if (diffInHours < 48) return 'Yesterday';
    return date?.toLocaleDateString();
  };

  return (
    <div
      onClick={onClick}
      className="bg-white rounded-lg shadow-sm border border-gray-200 p-5 hover:shadow-md transition-shadow cursor-pointer"
    >
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-2">
            <span className="text-sm font-mono text-gray-500">{ticket?.ticketNumber}</span>
            <span className={`px-2 py-1 rounded-full text-xs font-medium ${getPriorityColor(ticket?.priority)}`}>
              {ticket?.priority}
            </span>
            <div className="flex items-center gap-1 text-gray-600">
              {getStatusIcon(ticket?.status)}
              <span className="text-sm capitalize">{ticket?.status?.replace('_', ' ')}</span>
            </div>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">{ticket?.subject}</h3>
          <p className="text-gray-600 text-sm line-clamp-2">{ticket?.description}</p>
        </div>
      </div>
      <div className="flex items-center justify-between text-sm text-gray-500">
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-1">
            <User className="w-4 h-4" />
            <span>{ticket?.user?.fullName || 'Unknown User'}</span>
          </div>
          {ticket?.assignedAgent && (
            <div className="flex items-center gap-1">
              <User className="w-4 h-4 text-blue-600" />
              <span className="text-blue-600">{ticket?.assignedAgent?.fullName}</span>
            </div>
          )}
          <div className="flex items-center gap-1">
            <Clock className="w-4 h-4" />
            <span>{formatDate(ticket?.createdAt)}</span>
          </div>
        </div>
        
        {ticket?.tags && ticket?.tags?.length > 0 && (
          <div className="flex items-center gap-2">
            <Tag className="w-4 h-4" />
            <div className="flex gap-1">
              {ticket?.tags?.slice(0, 2)?.map((tag, index) => (
                <span
                  key={index}
                  className="px-2 py-0.5 bg-gray-100 text-gray-600 rounded text-xs"
                >
                  {tag}
                </span>
              ))}
              {ticket?.tags?.length > 2 && (
                <span className="px-2 py-0.5 bg-gray-100 text-gray-600 rounded text-xs">
                  +{ticket?.tags?.length - 2}
                </span>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TicketCard;